import Nullstack from 'nullstack';
export default function IconBrandMedium({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-medium",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "4",
    width: "16",
    height: "16",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M8 9h1l3 3l3 -3h1"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "15",
    x2: "10",
    y2: "15"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "15",
    x2: "16",
    y2: "15"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "9",
    x2: "9",
    y2: "15"
  }), "   ", Nullstack.element("line", {
    x1: "15",
    y1: "9",
    x2: "15",
    y2: "15"
  }), " ");
}